"use client";
import React, { createContext, useCallback, useMemo, useState } from "react";

export const ToastContext = createContext({
  show: false,
  type: "secondary",
  message: "",
  showToast: () => {},
  //   hideToast: () => {},
});

export const ToastProvider = ({ children }) => {
  const [state, setState] = useState({
    show: false,
    type: "secondary",
    message: "",
  });

  const showToast = useCallback(({ type = "inform", message = "" } = {}) => {
    // map custom types to Bootstrap variants
    const variant =
      type === "error"
        ? "danger"
        : type === "success"
        ? "success"
        : type === "inform"
        ? "info"
        : type || "secondary";

    // replace any existing toast (single-toast behavior)
    setState({ show: true, type: variant, message });
  }, []);

  if (state?.show) {
    setTimeout(() => {
      setState({ show: false, type: "secondary", message: "" }); // Hide the toast after the specified time
    }, 3000);
  }

  const value = useMemo(() => ({ ...state, showToast }), [state, showToast]);

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};
